import isNil from 'lodash-es/isNil';
import { usePlanFeat } from '../billing';
/**
 * @param org to test
 * @returns an array of metric ids
 */
const useRestrictedMetrics = (billingStatus) => {
    const planFeature = usePlanFeat('WEE-FEAT-OBSERVED-FILTERED-METRICS', billingStatus);
    const { active: isFeatActive, params: filteredMetrics } = !isNil(planFeature)
        ? planFeature
        : { active: false, params: [] };
    const restrictedMetrics = isFeatActive ? filteredMetrics : [];
    return restrictedMetrics;
};
export default useRestrictedMetrics;
